import {
  useBusinessProfilePlaylistPublishMutation,
  ZvukPlaylistPublishMutationInput,
} from 'domain/api/graphql/generated';
import { BaseMutationResultType, FetchPolicyKeys } from 'domain/api/graphql/types';

import { UseBusinessProfilePlaylistPublishType } from './types';

const useBusinessProfilePlaylistPublish = (): UseBusinessProfilePlaylistPublishType => {
  const [publishMutation, publishMutationResult] = useBusinessProfilePlaylistPublishMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: ZvukPlaylistPublishMutationInput) => {
    const publishMutationData = await publishMutation({
      variables: {
        input,
      },
      refetchQueries: ['zvukProfileList'],
    });

    return {
      isOk: !!publishMutationData.data?.zvukPlaylistPublish?.ok,
      playlist: publishMutationData.data?.zvukPlaylistPublish?.playlist,
    };
  };

  const result: BaseMutationResultType = {
    error: publishMutationResult.error,
    loading: publishMutationResult.loading,
    called: publishMutationResult.called,
  };

  return [request, result];
};

export default useBusinessProfilePlaylistPublish;
